module.exports = __webpack_public_path__ + "img/191.6e681424.jpg";